/**
 * Minimal className combiner, mirroring the local copies in seeds-react-list,
 * seeds-react-profile and seeds-react-tree —
 * @sproutsocial/seeds-react-utilities does NOT export a `cn` helper.
 *
 * Falsy inputs are dropped; object inputs contribute each truthy key.
 */
export function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}
